"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2009ToJSON = exports.InlineResponse2009FromJSONTyped = exports.InlineResponse2009FromJSON = void 0;
function InlineResponse2009FromJSON(json) {
    return InlineResponse2009FromJSONTyped(json, false);
}
exports.InlineResponse2009FromJSON = InlineResponse2009FromJSON;
function InlineResponse2009FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentMethods': json['paymentMethods'],
    };
}
exports.InlineResponse2009FromJSONTyped = InlineResponse2009FromJSONTyped;
function InlineResponse2009ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentMethods': value.paymentMethods,
    };
}
exports.InlineResponse2009ToJSON = InlineResponse2009ToJSON;
